import React, { useEffect } from "react";
import styled, { keyframes } from "styled-components";
import { DateRange, AccountBalance, CreditCard, Description } from "@material-ui/icons";
import Rules from "../rules";

function TabVencimento({
  values,
  touched,
  errors,
  handleChange,
  setFieldValue,
}) {
  useEffect(() => {
    console.log(values);
  }, [values]);

  const ruleTypes = [
    {
      type: "adiantamento",
      title: "Adiantamento",
      icon: <DateRange />,
      color: "#3498db",
    },
    {
      type: "entrada",
      title: "Nota fiscal de Entrada",
      icon: <Description />,
      color: "#27ae60",
    },
    {
      type: "lcm",
      title: "LCM",
      icon: <AccountBalance />,
      color: "#f39c12",
    },
    {
      type: "card",
      title: "Vencimento cartão de crédito",
      icon: <CreditCard />,
      color: "#9b59b6",
    },
  ];

  return (
    <ModernFormContainer>
      {values.id === 0 ? (
        <EmptyState>
          <DateRange style={{ fontSize: '64px', color: '#cbd5e1', marginBottom: '16px' }} />
          <EmptyTitle>Regras de Vencimento</EmptyTitle>
          <EmptyText>Salve a configuração primeiro para definir as regras de vencimento</EmptyText>
        </EmptyState>
      ) : (
        <RulesGrid>
          {ruleTypes.map((rule, index) => (
            <RuleCard key={index}>
              <RuleHeader>
                <RuleIcon color={rule.color}>
                  {rule.icon}
                </RuleIcon>
                <RuleTitle>{rule.title}</RuleTitle>
              </RuleHeader>
              <RuleContent>
                <Rules
                  type={rule.type}
                  setFieldValue={setFieldValue}
                  values={values}
                />
              </RuleContent>
            </RuleCard>
          ))}
        </RulesGrid>
      )}
    </ModernFormContainer>
  );
}

export default TabVencimento;

// Animações
const fadeIn = keyframes`
  from {
    opacity: 0;
    transform: translateY(10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
`;

const ModernFormContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
  font-family: 'Mulish', sans-serif;
`;

const RulesGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 24px;

  @media (max-width: 1200px) {
    grid-template-columns: 1fr;
  }
`;

const RuleCard = styled.div`
  background: white;
  border-radius: 16px;
  padding: 24px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
  border: 1px solid #e8e8e8;
  animation: ${fadeIn} 0.5s ease;
  transition: all 0.3s ease;

  &:hover {
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
    border-color: #d0d0d0;
  }
`;

const RuleHeader = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 20px;
  padding-bottom: 16px;
  border-bottom: 2px solid #f0f0f0;
`;

const RuleIcon = styled.div`
  width: 40px;
  height: 40px;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: ${props => props.color ? `${props.color}15` : '#667eea15'};
  color: ${props => props.color || '#667eea'};
  margin-right: 12px;
  transition: all 0.3s ease;

  svg {
    font-size: 22px;
  }

  ${RuleCard}:hover & {
    transform: scale(1.1);
  }
`;

const RuleTitle = styled.h3`
  font-size: 16px;
  font-weight: 700;
  color: #2c3e50;
  margin: 0;
  font-family: 'Mulish', sans-serif;
`;

const RuleContent = styled.div`
  width: 100%;
`;

const EmptyState = styled.div`
  width: 100%;
  padding: 64px 48px;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  background: white;
  border-radius: 16px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
  border: 1px solid #e8e8e8;
  font-family: 'Mulish', sans-serif;
`;

const EmptyTitle = styled.h3`
  font-size: 20px;
  font-weight: 700;
  color: #2c3e50;
  margin: 0 0 8px 0;
  font-family: 'Mulish', sans-serif;
`;

const EmptyText = styled.p`
  font-size: 14px;
  color: #7f8c8d;
  margin: 0;
  max-width: 400px;
  line-height: 1.5;
  font-family: 'Mulish', sans-serif;
`;
